export default __webpack_public_path__ + "static/1100-e9265f1751588ff74d14dc1e5477878d.gif";